export default {
  title: '取得驗證碼',
  type: 'post',
  body: [
    {
      title: '成功',
      body: {
        "code": 200,
        "message": "success",
        "status": "SUCCESS",
        "data": null
      }
    },
    {
      title: '驗證碼冷卻中',
      body: {
        "code": 403,
        "message": "Merchant member front send verification code in cool down",
        "status": "MERCHANT_MEMBER_FRONT_SEND_VERIFICATION_CODE_IN_COOL_DOWN",
        "data": null
      }
    }
  ]
}
